import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import Vue from "vue";
import "../styles/global.scss";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
